import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import type { Slots } from '../dialogue';
import { slotsSchema } from '../dialogue';
import { SENTIENCE_INPUT } from './topics';
import type { NLPEngineIntent } from './nlpEngineIntents';
import { nlpEngineIntents } from './nlpEngineIntents';

export const INTENT = 'SENTIENCE/INTENT';

export interface IIntentPayload {
  conversationId: string;
  consoleId: string;
  organisationId: string;
  intent: NLPEngineIntent;
  slots?: Slots;
  text?: string;
  confidence?: number;
  messageId?: string;
  recordingId?: string;
}

export const intentPayloadSchema = objectSchemaOf<IIntentPayload>({
  conversationId: Joi.string().required(),
  consoleId: Joi.string().required(),
  organisationId: Joi.string().required(),
  intent: Joi.string()
    .valid(...nlpEngineIntents)
    .required(),
  slots: slotsSchema.optional(),
  text: Joi.string().optional(),
  confidence: Joi.number().optional(),
  messageId: Joi.string().optional(),
  recordingId: Joi.string().optional(),
});

export interface IIntentAction {
  type: typeof INTENT;
  payload: IIntentPayload;
}

export const intentActionSchema = objectSchemaOf<IIntentAction>({
  type: Joi.string().valid(INTENT),
  payload: intentPayloadSchema.required(),
});

export const intent = actionCreator({
  schema: intentActionSchema,
  topic: SENTIENCE_INPUT,
  type: INTENT,
});
